import { API_BASE, http } from "./http";

export type PosExportKind = "sales" | "receipts" | "invoices" | "non_fiscal";

export type PosExportDevice = {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
};

export type PosExportPreview = {
  ok: boolean;
  kind: PosExportKind;
  from: string;
  to: string;
  posCode: string | null;
  rows: number;
  filename: string;
  sample: Array<Record<string, unknown>>;
};

function buildQuery(params: {
  kind: PosExportKind;
  from: string;
  to: string;
  posCode?: string;
}) {
  const sp = new URLSearchParams();
  sp.set("kind", params.kind);
  sp.set("from", params.from);
  sp.set("to", params.to);
  if (params.posCode?.trim()) sp.set("posCode", params.posCode.trim().toUpperCase());
  return sp.toString();
}

export const posExportsApi = {
  listDevices(token: string) {
    return http<{ ok: boolean; items: PosExportDevice[] }>("/pos/exports/devices", { method: "GET" }, token);
  },

  preview(
    token: string,
    params: { kind: PosExportKind; from: string; to: string; posCode?: string },
  ) {
    return http<PosExportPreview>(`/pos/exports/preview?${buildQuery(params)}`, { method: "GET" }, token);
  },

  async download(
    token: string,
    params: { kind: PosExportKind; from: string; to: string; posCode?: string },
  ) {
    const res = await fetch(`${API_BASE}/pos/exports/download?${buildQuery(params)}`, {
      method: "GET",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || `Download fallito HTTP ${res.status}`);
    }
    const blob = await res.blob();
    const disposition = res.headers.get("Content-Disposition") || "";
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    const filename = match?.[1] || `export_${params.kind}.csv`;
    return { blob, filename, rows: Number(res.headers.get("X-Row-Count") || 0) };
  },
};
